export default {
  "common.1": "DICA",
  "common.2": "Confirme",
  "common.3": "Depósito",
  "common.4": "Saque",
  "common.5": "Nota",
  "common.6": "Cancelar",
  "common.7": "Recebido com sucesso",
  "common.8": "Tarefas do sistema",
  "common.9": "Q&A",
  "common.10": "Registros detalhados",
  "common.12": "Sucesso",
  "common.13": "Falhar",
  "common.14": "Em curso",
  "common.20": "Receber",
  "common.21": "Ainda não há dados!",
  "common.22": "O tempo da solicitação expirou, tente novamente mais tarde",
  "common.23": "Parabéns",
  "home.1": "Prêmio",
  "home.2": "Bônus",
  "home.4": "Popular",
  "home.22": "Parabéns <span style='color: #3ACAFF;'>{userName} </span> por ganhar dinheiro <span style='color: #FFD645;'>{amount}</span>",
  "home.26": "Casino",
  "home.27": "Carteira",
  "home.28": "Aliança",
  "home.29": "Minha",
  "home.44": "Nível VIP atual:",
  "home.45": "O SuperWin777 está comprometido em proporcionar aos jogadores uma experiência de jogo duradoura, emocionante e divertida. Passamos por todas as verificações de conformidade e temos autorização legal para conduzir todas as operações de jogos de azar e apostas. Os retornos finais não podem ser garantidos.",
  "home.46": "Parceiros",
  "home.47": "A conta está anormal, verifique as informações da conta",
  "bouns.1": "Recarga com cashback",
  "bouns.3": "Cashback",
  "bouns.13": "Descrição da regra",
  "bouns.14": "1.Após participar com sucesso da promoção e concluir o depósito, o valor do cashback será creditado automaticamente na sua conta do jogo, sem necessidade de resgate manual.\n2.Esta atividade de cashback é dividida em três vezes, você precisa participar em sequência e pode iniciar o segundo depósito após concluir o primeiro.\n3.Cada usuário só pode participar desta atividade uma vez. Se o sistema detectar o mesmo endereço IP, conta bancária, endereço de e-mail e outras informações relacionadas, será considerado o mesmo usuário. Caso seja encontrada alguma fraude, a plataforma tem o direito de cancelar todas as recompensas de cashback e encerrar a conta relevante.\n4.Esta plataforma reserva-se o direito de interpretação final deste evento",
  "bouns.16": "1º depósito",
  "bouns.17": "2º depósito",
  "bouns.18": "3º depósito",
  "vip.3": "Prêmio Mensal",
  "vip.4": "Privilégios de retirada",
  "vip.8": "Atualizar VIP",
  "vip.11": "Faça {count} depósito",
  "vip.12": "Faça login por 30 dias consecutivos",
  "vip.14": "Ajude 2 membros subordinados a completar 1 recarga",
  "vip.15": "Recompensas de atualização",
  "vip.19": "Os benefícios do <span style='color:#FF8D24;'>VIP{level}</span> são os seguintes",
  "vip.25": "Benefícios VIP{level}",
  "vip.29": "Nível VIP",
  "vip.30": "Atualize para VIP{level}",
  "vip.31": "Reembolso de Apostas em Jogos",
  "vip.32": "Slots",
  "vip.33": "Jogos de cartas",
  "vip.34": "Esportes",
  "vip.35": "Pescar",
  "vip.36": "Aposta:<span style = 'color: #FFD645;'>{amount1}</span>/{amount2}",
  "vip.37": "Torne-se um VIP e aproveite os seguintes benefícios exclusivos",
  "vip.38": "Faça upgrade para usuário VIP1 com qualquer depósito",
  "vip.39": "Obter",
  "vip.40": "Valor máximo de retirada",
  "vip.41": "Atenda a qualquer um dos seguintes critérios para se tornar VIP",
  "vip.42": "Nível VIP",
  "vip.43": "Deposite {amount} ou mais",
  "vip.46": "Obter",
  "vip.47": "Ajude 2 membros subordinados a completar um depósito",
  "vip.48": "Valor do depósito",
  "invite.1": "Jogue com amigos",
  "invite.2": "Compartilhe em seu círculo social de amigos",
  "invite.3": "Compartilhe o link com seus amigos",
  "invite.4": "Cópia",
  "invite.5": "Copiado com sucesso",
  "invite.6": "Meus subordinados diretos",
  "invite.7": "{personCount} pessoas",
  "invite.8": "Condições de usuário válidas",
  "invite.9": "Depósito acumulado",
  "invite.10": "Subordinar",
  "invite.11": "Válido",
  "invite.12": "Nome",
  "invite.13": "Descrição do evento",
  "invite.14": "1. Convide um número correspondente de novos jogadores para abrir o baú do tesouro e receber recompensas.\r\n2. O usuário convidado deve concluir o cadastro através do seu link de convite exclusivo.\r\n3. O usuário convidado será considerado um usuário convidante válido somente após concluir o depósito do valor especificado.\r\n4. A empresa reserva-se o direito de interpretação final deste evento.",
  "proxy.1": "Atividades do agente",
  "proxy.2": "Convidar",
  "proxy.3": "Meus Links",
  "proxy.4": "Desenvolvimento e recompensas para subordinados",
  "proxy.5": "Comissão Direta",
  "proxy.6": "Nível",
  "proxy.7": "Rollover equipe",
  "proxy.8": "Proporção",
  "proxy.9": "1.Quando seus subordinados fizerem apostas no jogo, você receberá recompensas correspondentes.\n2. A empresa reserva-se o direito de interpretação final deste evento",
  "proxy.10": "Os meus dados",
  "proxy.11": "Comissão Total",
  "proxy.12": "Apostas totais",
  "proxy.13": "Total de registros",
  "proxy.14": "Detalhado",
  "proxy.15": "Minha Comissão",
  "proxy.16": "Jogadores diretos",
  "proxy.17": "Valor da aposta",
  "proxy.18": "A comissão do dia será creditada em sua conta após liquidação no início da manhã",
  "betRefund.1": "Cashback de apostas",
  "betRefund.2": "Apostas",
  "betRefund.3": "Retorno",
  "betRefund.4": "Progresso da promoção",
  "betRefund.5": "Próximo retorno {rate}",
  "betRefund.6": "Tabela de Referência de Rebate",
  "betRefund.7": "Valor da aposta",
  "betRefund.8": "Taxa de retorno",
  "betRefund.9": "1. Os usuários podem receber recompensas de cashback ao fazer apostas no jogo, e o valor do cashback é calculado com base em uma determinada porcentagem do valor total da aposta.\r\n2. Somente apostas reais e válidas podem participar do cashback, e o sistema excluirá automaticamente apostas inválidas ou anormais.\r\n3. Esta plataforma reserva-se o direito de interpretação final deste evento.",
  "lossRefund.1": "Cashback sobre perdas",
  "lossRefund.2": "Perda no dia",
  "lossRefund.3": "Valor da perda de ontem",
  "lossRefund.4": "Valor de reembolso",
  "lossRefund.5": "Tabela de referência de cashback de perda",
  "lossRefund.6": "Perdas no jogo",
  "lossRefund.7": "Taxa de Resgate",
  "lossRefund.8": "1. Os usuários podem usufruir de subsídios de cashback para perdas líquidas sofridas no jogo, e o valor do cashback é calculado de acordo com a tabela de referência de cashback para perdas.\r\n2. Somente perdas elegíveis em apostas no jogo podem participar do cashback, e nenhum reembolso será concedido por violações ou comportamentos anormais.\r\n3. Se o jogador não receber o desconto em dinheiro hoje, será considerado que o jogador desistiu.\r\n4. Qualquer trapaça ou comportamento malicioso de arbitragem resultará em desqualificação.\r\n5. Esta plataforma reserva-se o direito final de interpretação deste evento.",
  "record.1": "TIpo",
  "record.2": "Quantia",
  "record.3": "Estado",
  "record.4": "Número do pedido",
  "service.1": "Atendimento ao Cliente",
  "service.2": "Horário de funcionamento: 08h00~24h00",
  "service.3": "Como sacar fundos?",
  "service.4": "A retirada é um benefício exclusivo para membros. Você pode fazer upgrade para usuário VIP1 após concluir qualquer depósito. Após a atualização, você pode sacar fundos imediatamente.",
  "service.5": "O que fazer se não receber os fundos após uma recarga bem-sucedida?",
  "service.6": "1. Aguarde alguns minutos. Alguns pagamentos podem sofrer atrasos.\n2. Verifique se o pagamento foi bem-sucedido e faça uma captura de tela do recibo de pagamento para entrar em contato com o atendimento ao cliente para obter assistência.",
  "service.7": "O que devo fazer se o saque falhar ou não for recebido?",
  "service.8": "1. Por favor, confirme cuidadosamente se as informações da conta de retirada estão corretas\r\n2. Se as informações da conta estiverem corretas e os saques tiverem falhado várias vezes, é recomendável alterar a conta e reiniciar uma solicitação de saque.",
  "service.9": "Existe alguma taxa para retirada?",
  "service.10": "Tenha certeza de que o Superwin777 nunca cobrará nenhuma taxa de retirada e está comprometido em criar um ambiente de jogo justo e transparente para os jogadores",
  "service.11": "Há alguma restrição para saques?",
  "service.12": "O limite de retirada aumenta com o nível VIP. Quanto maior o nível, maior o limite de retirada.",
  "withdraw.1": "Conta de retirada",
  "withdraw.2": "Adicionar conta de saque",
  "withdraw.3": "Valor que pode ser sacado",
  "withdraw.4": "Selecione o valor do saque",
  "withdraw.5": "Valor de saque escolhido",
  "withdraw.11": "Saldo insuficiente disponível para retirada",
  "withdraw.14": "A ordem de saque foi enviada ao banco, preste atenção às alterações da conta bancária",
  "withdraw.15": "Valor máximo de retirada",
  "withdraw.16": "O valor máximo de retirada é o valor real da conta",
  "withdraw.17": "O pedido de retirada está sendo processado",
  "withdraw.18": "Retirada em andamento",
  "charge.1": "Selecione o valor do depósito",
  "charge.2": "Participe de atividades",
  "charge.3": "Prêmios especiais para novos usuários",
  "charge.4": "Valor do depósito",
  "charge.5": "Valor do cashback",
  "charge.7": "Não participar do evento",
  "charge.8": "charge.8    /*no value*/",
  "charge.9": "charge.9    /*no value*/",
  "account.bind.1": "Adicionar chave pix de saque",
  "account.bind.2": "Tipo de chave pix",
  "account.bind.3": "Por favor, selecione",
  "account.bind.4": "Chave PIX",
  "account.bind.5": "CPF",
  "account.bind.6": "Nome de usuário",
  "account.bind.7": "Por favor, insira seu nome de usuário",
  "account.bind.8": "Por favor insira o número da sua conta Pix",
  "account.bind.9": "Por favor insira seu CPF",
  "account.bind.10": "Erro de formato",
  "account.bind.11": "account.bind.11    /*no value*/",
  "account.bind.12": "account.bind.12    /*no value*/",
  "account.bind.13": "account.bind.13    /*no value*/",
  "account.bind.14": "Número de telefone",
  "account.bind.15": "Por favor, insira seu número de telefone",
  "times.1": "times.1    /*no value*/",
  "times.2": "times.2    /*no value*/",
  "times.3": "times.3    /*no value*/",
  "times.4": "times.4    /*no value*/",
  "times.5": "times.5    /*no value*/",
  "times.6": "times.6    /*no value*/",
  "my.1": "Registro",
  "my.2": "Linguagem",
  "my.3": "Convidar",
  "prop.1": "Caro usuário:\n     O valor que você sacou atingiu o limite máximo de saque para o nível <span style=\"color: #FF990B;\">VIP{vipLevel}</span> atual. Atualize seu nível VIP para aumentar o limite de saque antes de fazer um saque.",
  "prop.2": "Aumentar o valor da retirada",
  "prop.4": "Parabéns por receber a recompensa de reembolso de recarga exclusiva! Sua recompensa em dinheiro de <span style=\"color: #FF990B;\">{amount}</span> foi adicionada à sua conta。Os bônus podem ser retirados diretamente sem rotatividade do jogo",
  "prop.5": "Vá para visualizar",
  "prop.6": "Parabéns por atualizar para usuário <span style=\"color: #FF990B;\">VIP{vipLevel}</span>. Seu bônus de atualização de <span style='color: #FF990B;'>{amount}</span> foi emitido para sua conta. por favor, verifique.",
  "prop.8": "Aumente o nível VIP",
  "prop.11": "O saldo da sua conta corrente é insuficiente e é inferior ao valor mínimo da aposta",
  "prop.12": "Entre no jogo",
  "prop.14": "Recompensas em dinheiro",
  "prop.15": "Parabéns, você recebeu uma recompensa em dinheiro de R$ 10. Entre no jogo agora para ter a chance de ganhar mais super prêmios",
  "prop.19": "Deposite R$10,00 para se tornar VIP1 e você poderá sacar dinheiro",
  "prop.21": "Caro usuário:\n      Seu limite de saque atual do nível VIP é de {amount}. Selecione {amount} para sacar ou faça upgrade para VIP2 para obter um valor de saque maior.",
  "prop.22": "Selecione {amount}",
  "prop.35": "<div style='color: #FFB947; font-size: 16rem; font-weight: bold;'>Seu saldo agora está disponível para saque!</div>\nDeposite <span style='color: #FFB947;'>R$10,00</span> para fazer upgrade para <span style='color: #FFB947;'>VIP1</span> e obter qualificação para saque em dinheiro",
  "prop.36": "Saldo disponível para saque {amount}",
  "prop.37": "Depósito {amount}",
  "prop.38": "Deposite <span style='color: #FFB947;'>R$100,00</span> e faça upgrade para <span style='color: #FFB947;'>VIP2</span>!\nO limite máximo de saque para <span style='color: #FFB947;'>VIP2</span> é de <span style='color: #FFB947;'>R$10.000,00</span>.\nApós se tornar VIP2 você pode sacar o valor total imediatamente",
  "prop.39": "100% de cashback em depósitos\n O bônus pode ser retirado diretamente!",
  "prop.40": "Detalhes",
  "prop.41": "Deposite agora",
  "prop.42": "O nível VIP atual é insuficiente. Você pode escolher jogar outros jogos ou melhorar seu nível VIP.",
  "prop.43": "Jogue outros jogos",
  "prop.44": "Caro membro VIP1, você desbloqueou um valor de saque de R$10,00, vá e saque agora!",
  "prop.45": "prop.45    /*no value*/",
  "prop.46": "prop.46    /*no value*/",
  "prop.47": "prop.47    /*no value*/",
  "prop.48": "prop.48    /*no value*/",
  "prop.49": "prop.49    /*no value*/",
  "prop.50": "prop.50    /*no value*/",
  "prop.51": "prop.51    /*no value*/",
  "orderview.1": "orderview.1    /*no value*/",
  "orderview.2": "orderview.2    /*no value*/",
  "orderview.3": "orderview.3    /*no value*/",
  "orderview.4": "orderview.4    /*no value*/",
  "orderview.5": "orderview.5    /*no value*/",
  "orderview.6": "orderview.6    /*no value*/",
  "orderview.7": "orderview.7    /*no value*/",
  "orderview.8": "orderview.8    /*no value*/",
  "orderview.9": "orderview.9    /*no value*/",
  "orderview.10": "orderview.10    /*no value*/",
  "orderview.11": "orderview.11    /*no value*/",
  "orderview.12": "orderview.12    /*no value*/",
  "orderview.13": "orderview.13    /*no value*/",
  "orderview.14": "orderview.14    /*no value*/",
  "orderview.15": "orderview.15    /*no value*/",
  "orderview.16": "orderview.16    /*no value*/",
  "orderview.17": "orderview.17    /*no value*/",
  "orderview.18": "orderview.18    /*no value*/",
  "orderview.19": "orderview.19    /*no value*/",
  "orderview.20": "orderview.20    /*no value*/",
  "orderview.21": "orderview.21    /*no value*/",
  "orderview.22": "orderview.22    /*no value*/",
  "orderview.23": "orderview.23    /*no value*/",
  "orderview.24": "orderview.24    /*no value*/",
  "orderview.25": "orderview.25    /*no value*/",
  "orderview.26": "orderview.26    /*no value*/",
  "orderview.27": "orderview.27    /*no value*/",
  "orderview.28": "orderview.28    /*no value*/",
  "orderview.29": "orderview.29    /*no value*/",
  "orderview.30": "orderview.30    /*no value*/",
  "orderview.31": "orderview.31    /*no value*/",
  "orderview.32": "orderview.32    /*no value*/",
  "orderview.33": "orderview.33    /*no value*/",
  "orderview.34": "orderview.34    /*no value*/",
  "orderview.35": "orderview.35    /*no value*/",
  "orderview.36": "orderview.36    /*no value*/",
  "orderview.37": "orderview.37    /*no value*/",
  "orderview.38": "orderview.38    /*no value*/",
  "orderview.39": "orderview.39    /*no value*/",
  "orderview.40": "orderview.40    /*no value*/",
  "home.img.1": "gold_icon_br.png",
  "home.img.6": "home_icon_vip_br.png",
  "home.img.7": "home_icon_share_br.png",
  "banner.img.1": "banner_1_br.png",
  "banner.img.2": "banner_2_br.png",
  "banner.img.3": "banner_3_br.png",
  "banner.img.4": "banner_4_br.png",
  "banner.img.5": "banner_5_br.png",
  "banner.img.6": "banner_6_br.png",
  "banner.img.7": "banner_6_br.png",
  "activitys.img.1": "cash_des_br.png",
  "activitys.img.4": "newUser_bg_br.png",
  "activitys.img.6": "cash_amount_br.png",
  "activitys.img.8": "cash_item_complete_br.png",
  "activitys.img.9": "cash_max_br.png",
  "activitys.img.11": "cash_tip_2_br.png",
  "activitys.img.12": "cash_tip_3_br.png",
  "customer.img.1": "customerImg_br.png"
}